export default class AudioContext {
    
    constructor() {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        this.analyser = this.audioCtx.createAnalyser();
    }
    
    
    getAudioContext() {
        return this.audioCtx;
    }
    
    getAnalyser() {
        return this.analyser;
    }
    
}



// WEBPACK FOOTER //
// ./src/libs/AudioContext.js